module.exports = __webpack_public_path__ + "static/media/ETH.ab794f02.png";